import script from "./PagingControl.vue?vue&type=script&lang=ts&setup=true"
export * from "./PagingControl.vue?vue&type=script&lang=ts&setup=true"

import "./PagingControl.vue?vue&type=style&index=0&id=116af9ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116af9ac"]])

export default __exports__